module.exports = __webpack_public_path__ + "img/mind_icon_number_5.e99589d6.png";